import type { HeaterType, PlacementRulesResult, SaunaSiting } from '../../engines/types';
import type { Market } from '../location/types';
import { getT } from '../../i18n';

interface PlacementInput {
  heaterType: HeaterType;
  includesShower: boolean;
  siting?: SaunaSiting;
}

export function calculatePlacementRules({
  heaterType,
  includesShower,
  siting,
}: PlacementInput, market: Market = 'se'): PlacementRulesResult {
  const t = getT(market);

  // Issue 156: an indoor sauna is on no plot — the 4.5 m boundary and the 8 m
  // to a dwelling are rules for a free-standing building. What matters is the
  // room it goes into.
  if (siting === 'indoor') {
    return {
      indoor: true,
      boundaryDistanceM: 0,
      buildingDistanceM: 0,
      tips: [t.domain_place_indoorTipVentilation],
      checklist: [
        heaterType === 'wood'
          ? t.domain_place_indoorCheckWood
          : t.domain_place_indoorCheckElectric,
        t.domain_place_indoorCheckFloor,
      ],
    };
  }
  const buildingDistanceM = heaterType === 'wood' ? 8 : 0;
  const tips = [
    t.domain_place_tipElectrical,
    includesShower
      ? t.domain_place_tipDrainageShower
      : t.domain_place_tipDrainageNoShower,
  ];

  if (heaterType === 'wood') {
    tips.push(t.domain_place_tipWoodAirflow);
  }

  return {
    boundaryDistanceM: 4.5,
    buildingDistanceM,
    tips,
    checklist: [
      t.domain_place_checkBoundary,
      heaterType === 'wood'
        ? t.domain_place_checkWoodDistance
        : t.domain_place_checkElectricDistance,
      includesShower
        ? t.domain_place_checkDrainShower
        : t.domain_place_checkDrainNoShower,
    ],
  };
}
